import * as G6 from '@antv/g6';

import GraphEvent, { GraphEventType } from 'dashboard/components/GraphCanvasV2/events/graph-event';

export default class SelectionBoxMouseDownEvent extends GraphEvent<MouseEvent> {
  public static type = GraphEventType.SelectionBoxMouseDown;
  public graphTarget: G6.IShape;

  constructor(event: MouseEvent, graphTarget: G6.IShape) {
    super(GraphEventType.SelectionBoxMouseDown, event);
    this.graphTarget = graphTarget;
  }
}
